import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { OeeAppState } from '../../../store/oee.reducer';
import { Subscription } from 'rxjs';

@Component({
    selector: 'top-loader',
    templateUrl: './top-loader.component.html',
    styleUrls: ['./top-loader.component.scss'],
    standalone: false
})
export class TopLoaderComponent implements OnInit, OnDestroy {
  public topLoading$: boolean;
  private appStoreSubscription: Subscription;

  constructor(private store: Store<OeeAppState>) {}
  ngOnDestroy(): void {
    if (this.appStoreSubscription) {
      this.appStoreSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.appStoreSubscription = this.store.select('app').subscribe((state) => {
      this.topLoading$ = state.topLoading;
    });
  }
}
